import { useEffect, useState } from 'react';

// Returns ``value`` debounced by ``delay`` ms (default 300).
// Usage: const debounced = useDebouncedValue(search);
export function useDebouncedValue(value, delay = 300) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(t);
  }, [value, delay]);
  return debounced;
}
